import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { Paper, Button, TextField, Typography } from '@material-ui/core';
import { RegisterLink } from '../Register';
import { ForgotPasswordLink } from '../ForgotPassword';
import { auth } from '../../firebase';
import * as routes from '../../routes/routes';
import { toast } from 'react-toastify';
const LoginPage = ({ history }) => (
  <div>
    <Login history={history} />
  </div>
)

const updateByPropertyName = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      this.onSubmit(event)
    }
  }

  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;

    const {
      history,
    } = this.props;

    auth.signInWithEmailAndPassword(email, password)
      .then((user) => {
        if (user.user.emailVerified === true) {
          history.push(routes.DASHBOARD);
        } else {
          user.user.sendEmailVerification().then(function () {
            toast.error('Email not verified, please verify your email!A verification link has been sent to your email address! Please click the link to verify your account', {
              position: 'top-center',
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
            });
          })
          this.setState(() => ({ ...INITIAL_STATE }));
        }
      })
      .catch((error) => {
        this.setState(updateByPropertyName('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      email,
      password,
      error,
    } = this.state;

    const isInvalid = password === ''
      || email === '';

    return (
      <div className="padding-middle">
        <div style={{
          textAlign: 'center',
        }}
        >
          <Paper className="papper-middle">
            <TextField
              label="Email"
              required
              onChange={event => this.setState(updateByPropertyName('email', event.target.value))}
            />
            <br />
            <TextField
              type="password"
              label="Password"
              required
              onChange={event => this.setState(updateByPropertyName('password', event.target.value))}
            />
            <br />
            <Button
              disabled={isInvalid}
              className="formButton"
              onClick={this.onSubmit}
            >
              {'Login'}
            </Button>
            {error && <Typography className="message-error">{error.message}</Typography>}
            <ForgotPasswordLink />
          </Paper>
          <RegisterLink />
        </div>
      </div>
    );
  }
}

export default withRouter(LoginPage);

export {
  Login
};



// WEBPACK FOOTER //
// ./src/components/Login/index.js